import React, { useState, useEffect, useContext } from "react";
import { Table } from "@devexpress/dx-react-grid-material-ui";

import Spinner from "../../components/Spinner";
import JobSchedulesCalendar from "../../components/JobSchedules/JobSchedulesCalendar";
import StarekContext from "../../context/StarekContext";
import { useNavigate } from "react-router-dom";

const JobSchedules = (props) => {
  const starekContext = useContext(StarekContext);
  const [loadingPrimary, setLoadingPrimary] = useState(true);
  const [loading, setLoading] = useState(true);
  const [jobSchedule, setJobSchedule] = useState({});
  const lastUsedWorkspace = starekContext.lastUsedWorkspace;
  useEffect(() => {
    (async () => {
      try {
        const response = fetchJobSchedules();
      } catch (error) {
        starekContext.showErrorMessage(error.message);
      }
      setLoadingPrimary(false);
    })();
  }, []);

  const fetchJobSchedules = async () => {
    try {
      setLoading(true);
      if (!lastUsedWorkspace || !lastUsedWorkspace.engine) return;

      const { host, scheme, port } = lastUsedWorkspace.engine;
      const apiUrl = `${scheme}://${host}:${port}/api/v1/${lastUsedWorkspace.name}/graphql`;

      const query = {
        query: `
        {
          jobSchedules {
            id
            name
            created_at
            description
            cycle {
              created_at
              description
              id
              is_active
              name
              plant_id
              plant {
                code
                name
              }
            }  
            cycle_id
            part_id
            part {
              id
              name
              plant_id
              description
              is_active
            }
            end_time
            start_time
            plant_id
            plant {
              name
              id
            }
          }
        }
      `,
      };

      const token = starekContext.auth;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(query),
      });
      const result = await response.json();
      if (result.data) {
        setJobSchedule(result.data.jobSchedules);
      }
    } catch (error) {
      console.error("Error fetching job schedules:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loadingPrimary || loading) {
    return (
      <>
        <Spinner />
        <div className="text-xs d-flex justify-content-center">
          <i className="fa fa-gear fa-spin fa-2x"></i>
        </div>
      </>
    );
  }

  if (jobSchedule && jobSchedule.length > 0) {
    return (
      <JobSchedulesCalendar
        jobSchedules={jobSchedule}
        onRefresh={fetchJobSchedules}
      />
    );
  }

  return (
    <div className="tw-text-center tw-mt-10">
      <Spinner />
    </div>
  );
};

export { JobSchedules };
